module.exports = __webpack_public_path__ + "static/img/IMG_0430.8d9667e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0430.jpg
// module id = sa4/
// module chunks = 11